<template>
  <div class="flex flex-col items-center gap-4">
    <div class="w-22 h-22 dark:hidden" v-html="svg.light" />
    <div class="w-22 h-22 hidden dark:block" v-html="svg.dark" />
    <div class="font-body text-sm text-n-400 dark:text-n-0 first-letter:uppercase text-center">
      <slot />
    </div>
    <slot name="action" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import DizzyRobotDark from '../assets/svg/dizzy-robot-dark.svg?raw'
import DizzyRobot from '../assets/svg/dizzy-robot.svg?raw'
import EmptyCaseDark from '../assets/svg/empty-case-dark.svg?raw'
import EmptyCase from '../assets/svg/empty-case.svg?raw'
import WarningDark from '../assets/svg/warning-dark.svg?raw'
import Warning from '../assets/svg/warning.svg?raw'

interface Props {
  type: 'error' | 'empty' | 'warning' | string | { light: string; dark: string }
}

const props = withDefaults(defineProps<Props>(), {
  type: 'error'
})

const svg = computed(() => {
  if (props.type === 'empty') {
    return {
      light: EmptyCase,
      dark: EmptyCaseDark
    }
  } else if (props.type === 'warning') {
    return {
      light: Warning,
      dark: WarningDark
    }
  } else if (props.type === 'error') {
    return {
      light: DizzyRobot,
      dark: DizzyRobotDark
    }
  } else {
    return typeof props.type === 'string' ? { light: props.type, dark: props.type } : props.type
  }
})
</script>
